import * as React from 'react';
interface Props {
  url: string;
  height?: number,
  type?: number;
}
const Rule: React.FC<Props> = (props) => (
  <div className="rule-comp" style={{ width: (props.type || 2) === 2 ? ('1244px') : '10rem' }}>
    <iframe
      id="rules"
      width='100%'
      height={6700}
      className="rules"
      src={props.url}
      frameBorder="0"
    // onLoad={calcHeight}
    ></iframe>
  </div>
)

export default Rule;